import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { sanitizePayload } from "./sanitizePayload";

export interface ExpenseData {
  unitId: string;
  costCenterId: string;
  amount: number;
  date: Date;
  [key: string]: any;
}

export async function postExpense(data: ExpenseData & { createdBy?: string }) {
  if (!data.unitId || !data.costCenterId || data.amount === undefined || !data.date) {
    throw new Error("Missing required fields");
  }
  if (data.date > new Date()) {
    throw new Error("Future dates not allowed");
  }
  const now = serverTimestamp();
  const expenseDoc = sanitizePayload({
    ...data,
    createdBy: data.createdBy || "system",
    createdAt: now,
    updatedBy: data.createdBy || "system",
    updatedAt: now,
  });
  
  try {
    const result = await addDoc(collection(db, "expenses"), expenseDoc);
    return result;
  } catch (error: any) {
    console.error("=== POST EXPENSE ERROR ===");
    console.error("Error creating expense:", error);
    console.error("Error code:", error.code);
    console.error("Error message:", error.message);
    console.error("Full error object:", JSON.stringify(error, null, 2));
    throw error;
  }
}
